/* src/pages/project-steps/page-project-steps.component.scss */
:host {
  display: block;
}
.project-name {
  max-width: calc(50vw - 320px);
  width: calc(50vw - 320px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.project-name a {
  text-decoration: none;
  color: var(--vwui-color-dark);
}
.header-tab-bar {
  margin-top: var(--vwui--spacing--xs);
}
.header-tab-bar ::ng-deep .tabs {
  border: none;
  margin: 0;
}
.header-tab-bar ::ng-deep .tab {
  height: 5rem;
  white-space: nowrap;
}
.header-tab-bar ::ng-deep .indicator {
  top: 0;
  bottom: auto;
  height: 4px;
}
.header-menu {
  --vwui-btn-icon--size: 3rem;
  --vwui-btn-icon--bg: var(--vwui-color-neutral-4);
  --vwui-btn-icon--bg-hover: var(--vwui-color-neutral-3);
  --vwui-btn-icon--radius: var(--vwui-size-radius-sm);
  --vwui-btn-icon--icon-color: var(--vwui-color-dark);
}
.header-project-status {
  display: inline-block;
  vertical-align: top;
  margin: -1px var(--vwui--spacing--xxs) 0 0;
}
/*# sourceMappingURL=page-project-steps.component-QU34UBSA.css.map */
